
AGADash.Panel.Render = (function () {

    var defaultOptions = {
        canMinimizeOnTitle: false,
        isMinimized: false,
        canResize: false,
        canRemove: true,
        canSelectOtherPanel: false,
        isDetailColumn: false,
        isFullWidth: true
    };

    var renderDetailStruct = function (target) {
        var divClasses = ["dash-selector", "dash-filters", "dash-body", "dash-footer"];
        $(target).empty()
            .append(
            divClasses.map(function (cl) {
                var div = document.createElement("div");
                div.className = cl;
                return div;
            }));
    };

    var makeDiv = function (divClass, placeHolder) {
        var d = document.createElement("div");
        $(d).addClass(divClass);
        if (placeHolder)
            $(d).appendTo(placeHolder);
        return d;
    };

    var makeEle = function (elementName, divClass, placeHolder) {
        var e = document.createElement(elementName);
        if (divClass)
            $(e).addClass(divClass);
        if (placeHolder)
            $(e).appendTo(placeHolder);
        return e;
    };

    var makeAnchor = function (divClass, attributes, text, placeHolder) {
        var a = document.createElement("a");
        $(a).addClass(divClass).attr(attributes).text(text).appendTo(placeHolder);
        return a;
    };

    var renderTitle = function (title, options) {
        if (!options.canMinimizeOnTitle) {
            return makeDiv("caption", title);
        }

        var titleParent = document.createElement("a");
        $(titleParent).attr({ "href": "javascript:;" }).addClass("caption").appendTo(title);
        $(titleParent).on("click",
                function () {
                    var handled = false;
                    $(this)
                        .closest(".portlet-title")
                        .find("a")
                        .each(function (index, obj) {
                            if (!handled && ($(obj).hasClass("collapse") || $(obj).hasClass("expand"))) {
                                handled = true;
                                $(obj).trigger("click");
                            }
                        });
                });
        return titleParent;
    };

    var renderToolButtons = function (parent, opts) {

        var tools = AGADash.Repository.getPanelTools();
        tools.render(parent, tools.buttonNames.minimize, opts.isMinimized ? "expand" : "collapse");
        if (opts.canResize)
            tools.render(parent, tools.buttonNames.resize, opts.isFullWidth ? "aga-fullwidth" : "aga-halfwidth");
        tools.render(parent, tools.buttonNames.reload, "");

        if (opts.canRemove)
            tools.render(parent, tools.buttonNames.remove, "");

        /*
        if (options.canRemove) {
            var remLink = makeAnchor("aga-remove", { "href": "javascript:;", "data-original-title": "Remover" }, "", tools);
            $(remLink).on("click", function () { AGADash.Panel.removeHandler(this); });
        }
        */
    };

    var renderPortletStruct = function (target, opts) {
        var options = $.extend(defaultOptions, opts);

        var portlet = makeDiv("portlet light dash-portlet");
        var title = makeDiv("portlet-title", portlet);

        var titleParent = renderTitle(title, options);
        var titlePlace = makeEle("span", "caption-subject font-green-sharp bold uppercase dash-selector dash-title", titleParent);
        $(titlePlace).html('<i class="fa fa-spin fa-cog"></i>');

        // Renderizar seletor ------------------------------------------------------------
        var classSel = options.canSelectOtherPanel ? "" : " hide";
        var selector = makeDiv("btn-group" + classSel, titleParent);
        var a = makeAnchor("btn btn-sm", { "href": "javascript:;", "data-toggle": "dropdown", "aria-expanded": "false" }, "", selector);
        makeEle("i", "fa fa-plus", a);
        makeEle("ul", "dropdown-menu dash-panel-list", selector);
        ///-------------------------------------------------------------------------------

        // Tools
        var toolsPlaceholder = makeDiv("tools", title);
        renderToolButtons(toolsPlaceholder, options);

        // Actions
        var actions = makeDiv("actions", title);
        a = makeAnchor("aga-print btn btn-default hide", { "href": "javascript:;" }, "", actions);
        makeEle("i", "fa fa-print", a);
        $(a).append(" Imprimir");

        var portletBody = makeDiv("portlet-body", portlet);
        if (options.isMinimized)
            $(portletBody).hide();
        var row = makeDiv("row", portletBody);
        var col = makeDiv((options.isDetailColumn ? "col-md-6" : "col-md-12"), row);
        makeDiv("dash-filters", col);

        // Painel updating
        var updatingPanel = makeDiv("dash-updating", col);
        $(updatingPanel).attr("count", "0");
        makeEle("span", "fa fa-spin fa-refresh", updatingPanel);
        $(makeEle("span", "", updatingPanel)).text(" Atualizando...");

        makeDiv("dash-body", col);

        if (options.isDetailColumn) {
            var col2 = makeDiv("col-md-6", row);
            makeDiv("dash-footer", col2);
        }
        else
            makeDiv("dash-footer", col);

        $(target).empty().append(portlet);
    }

    return {
        renderDetailStruct: renderDetailStruct,
        renderPortletStruct: renderPortletStruct
    };

})();

AGADash.Repository.setPanelRender(AGADash.Panel.Render);